import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

interface IContact {
  title: string;
  image: string;
  info: string | undefined;
}

export const Contact = ({ title, image, info }: IContact) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack alignItems='center' gap={isDesktop ? '8px' : '4px'}>
      <Typography variant='body3'>{title}</Typography>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='center'
        gap='8px'
      >
        <Avatar alt='' src={image} sx={{ width: '20px', height: '20px' }} />
        <Typography variant='body2'>
          {info || Dictionary[DICTIONARY.B2C].UserContacts.noData}
        </Typography>
      </Stack>
    </Stack>
  );
};
